// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textField {
  width: 100%;
  padding-bottom: 20px !important;
}

.selectField {
  width: 100%;
  padding-bottom: 0px !important;
}

.textAreaField {
  width: 100%;
  padding-bottom: 20px !important;
  margin-bottom: 20px !important;
  border-color: lightgray;
}

.buttonField {
  width: 100%;
  padding: 20px !important;
}

.fileUploadField {
  width: 100%;
  padding-bottom: 10px !important;
  color: "#f12ef1";
}

a {
  color: green;
}

.aLink {
  color: red;
  background-color: red;
}
.aLink :hover {
  color: blue;
}

.rootContainer {
  display: flex;
  width: "100%";
}

.rootContainer > * {
  background-color: white;
  color: black;
  margin-right: 20px;
  font-size: 12px;
}

.downloadButton {
  margin-bottom: 20px !important;
}

.createReimburseHeaderText {
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 15px;
  color: rgb(87, 84, 84);
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/stripe/PlansCard.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,+BAAA;AACJ;;AAEA;EACI,WAAA;EACA,8BAAA;AACJ;;AAEA;EACI,WAAA;EACA,+BAAA;EACA,8BAAA;EAEA,uBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,wBAAA;AAAJ;;AAKA;EACI,WAAA;EACA,+BAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,YAAA;AAFJ;;AAIA;EACI,UAAA;EACA,qBAAA;AADJ;AAGI;EACI,WAAA;AADR;;AAMA;EACI,aAAA;EACA,aAAA;AAHJ;;AAOA;EAEI,uBAAA;EACA,YAAA;EACA,kBAAA;EAEA,eAAA;AANJ;;AAUA;EACI,8BAAA;AAPJ;;AAWA;EACI,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;AARJ;;AAWA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AARJ","sourcesContent":[".textField{\n    width:100%;\n    padding-bottom: 20px!important;\n    \n}\n.selectField{\n    width:100%;\n    padding-bottom: 0px!important;\n    \n}\n.textAreaField{\n    width:100%;\n    padding-bottom: 20px!important;\n    margin-bottom: 20px!important;\n   \n    border-color:lightgray;\n}\n\n.buttonField{\n    width:100%;\n    padding: 20px!important;\n    \n}\n\n\n.fileUploadField{\n    width:100%;\n    padding-bottom: 10px!important;\n    color:'#f12ef1'\n    \n}\na{\n    color:green;\n}\n.aLink{\n    color:red;\n    background-color: red;\n    \n    :hover{\n        color:blue;\n        \n    }\n}\n\n.rootContainer{\n    display: flex;\n    width:'100%';\n    //flex-flow: row  nowrap;\n    \n}\n.rootContainer> * {\n    \n    background-color: white;\n    color: black;\n    margin-right: 20px;\n    \n    font-size: 12px;\n    \n}\n\n.downloadButton{\n    margin-bottom:20px!important;\n    \n}\n\n.createReimburseHeaderText{\n    font-size:16px;\n    font-weight: bold;\n    padding-bottom:15px;\n    color:rgb(87, 84, 84);\n}\n\n.loading-state {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.3);\n    z-index: 9999;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
